import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {MaterialStorage, MaterialStorageDTO} from '../types'

type Variables = {plantCode: string; dto: MaterialStorageDTO}

export const useAddMaterialStorage = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: MaterialStorage, variables: Variables) => void
} = {}) =>
  useMutation<MaterialStorage, AxiosError, Variables>({
    mutationFn: async ({plantCode, dto}) => {
      const response = await ApiClient.axiosInstance.post<MaterialStorage>(
        `/plants/${plantCode}/material-storage`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess
  })
